const customerPurchasesId = {
	customer_purchases: {
		title: "Laporan Pembelian",
		empty_state: {
			title: "Belum ada data laporan pembelian",
			description: "Laporan akan muncul setelah pelanggan melakukan pembelian.",
		},
		tables: {
			title: "Laporan Pembelian Pelanggan",
			columns: {
				name: "Nama",
				phone_number: "Nomor HP",
				email: "Email",
				qty: "Qty",
				total: "Total Pembelian",
			},
		},
	},
};

export default customerPurchasesId;
